/* eslint-disable no-undef */
APP.Swiper = function (mobilEl, topBarInstance, screens) {
  this.mobil = mobilEl;
  this.screens = screens || Array.prototype.slice.call(document.querySelectorAll('.screen'));

  this.pagination = document.querySelector('.swiper-pagination');
  this.pagination.style.visibility = 'hidden';

  this.topBar = topBarInstance;
  this.mobileBg = 0;

  this.buttonNext = document.querySelector('.swipe-button.next');
  this.buttonPrev = document.querySelector('.swipe-button.prev');
};

APP.Swiper.prototype.destroy = function () {
  // eslint-disable-next-line no-unused-expressions
  this.swiper && this.swiper.destroy && this.swiper.destroy(true, true);
  this.swiper = null;
};

APP.Swiper.prototype.init = function () {
  this.destroy();
  this.setSlidesHeight();
  this.swiper = new Swiper('.swiper-container', {
    direction: 'vertical',
    slidesPerView: 1,
    spaceBetween: 0,
    mousewheelControl: true,
    keyboardControl: true,
    nextButton: '.swipe-button.next',
    pagination: '.swiper-pagination',
    paginationClickable: true,
  });

  this._attachEvents();
};

APP.Swiper.prototype.setSlidesHeight = function () {
  var slides = Array.prototype.slice.call(document.querySelectorAll('.swiper-slide'));
  document.querySelector('.swiper-container').style.height = window.innerHeight + 'px';
  slides.forEach(function (slide) {
    slide.style.height = window.innerHeight + 'px';
  });
  setTimeout(
    function () {
      if (this.swiper && Math.abs(this.swiper.height - window.innerHeight) > 10) {
        this.init();
      }
    }.bind(this),
    100
  );
};

APP.Swiper.prototype._setSlidesAutoHeight = function () {
  var slides = Array.prototype.slice.call(document.querySelectorAll('.swiper-slide'));
  slides.forEach(function (slide) {
    slide.style.height = 'auto';
  });
};

APP.Swiper.prototype._attachEvents = function () {
  this.swiper.on(
    'slideChangeStart',
    function (swiper) {
      var isLast = swiper.slides.length === swiper.activeIndex + 1;
      if (isLast) {
        this.mobil.classList.add('invisible');
      }
      this.screens.forEach(function (screen) {
        screen.classList.remove('played');
        var video = screen.querySelector('video');
        if (video) {
          // video.removeEventListener("ended", playVideo);
        }

        return screen;
      });

      /* od druheho slidu vycentrujeme telefon vertikalne */
      if (swiper.activeIndex > 0) {
        //setMobileTop(mobil, Math.max(header.offsetHeight, (window.innerHeight-mobil.offsetHeight)/2));
        //buttonPlay.style.display = "block";
        this.pagination.style.visibility = 'visible';
      } else {
        //setMobileTop(mobil, mobilBaseTop)
        this.pagination.style.visibility = 'hidden';
        //buttonPlay.style.display = "none";
      }

      /* od druheho slidu zobrazime horni listu */
      if (swiper.activeIndex > 0) {
        this.topBar.topBarSwitch(true);
      } else {
        this.topBar.topBarSwitch(false);
      }

      /* pri velkem rozliseni pridame na pozadi prvniho slidu druhy telefonek */
      if (swiper.activeIndex === 0 && window.innerWidth >= 1280) {
        this.mobileBg = 1;
      } else {
        this.mobileBg = 0;
      }
    }.bind(this)
  );

  this.swiper.on(
    'slideChangeEnd',
    function (swiper) {
      /* skryjeme/zobrazime scrollovaci buttony */
      var isLast = swiper.slides.length === swiper.activeIndex + 1;
      this.buttonNext.classList[isLast ? 'add' : 'remove']('hidden');
      this.buttonPrev.classList[isLast ? 'remove' : 'add']('hidden');
      if (!isLast) {
        this.mobil.classList.remove('invisible');
      }

      /* skryjeme/zobrazime screeny na telefonu */
      this.screens.forEach(function (screen, i) {
        screen.classList[i === swiper.activeIndex ? 'add' : 'remove']('active');
        var video = screen.querySelector('video');
        if (i === swiper.activeIndex && video) {
          // video.addEventListener("ended", playVideo)
        }
      });

      this.mobil.classList[this.mobileBg === 1 ? 'add' : 'remove']('show');
    }.bind(this)
  );

  this.buttonPrev.addEventListener(
    'click',
    function () {
      this.swiper.slideTo(0);
    }.bind(this)
  );
};
